import {
    BeforeSaveFunction,
    DeleteConfirmationFunction,
    PageHeader,
    PageValidatorFunction,
    RecordActionButton,
    RecordActionFunction
} from "./PageHeader";
import {WorkEntryDialogParams} from "@/common-dialogs/WorkEntryDialog";

export class NullPageHeader implements PageHeader {
    get cancelUrl(): string|undefined {
        return undefined;
    }

    addBeforeSaveHandler(_beforeSaveHandler: BeforeSaveFunction): void { /* do nothing */ }

    addDeleteConfirmationHandler(_handler: DeleteConfirmationFunction): void { /* do nothing */ }

    addPageValidator(_pageValidator: PageValidatorFunction): void { /* do nothing */ }

    enableRecordActionButton(_button: RecordActionButton, _state: boolean): void { /* do nothing */ }

    markPageDirty(_section?: string | Event): void { /* do nothing */ }

    performSave(): Promise<void> {
        return Promise.resolve(undefined);
    }

    performValidation(_optionalForm?: HTMLElement): Promise<void> {
        return Promise.resolve(undefined);
    }

    promptIfDirtyBeforeContinuingP(): Promise<void> {
        return Promise.resolve(undefined);
    }

    resetDirtyFlag(_section?: string): void { /* do nothing */ }

    setCancelHandler(_cancelFunc: RecordActionFunction): void { /* do nothing */ }

    setDeleteHandler(_deleteFunc: RecordActionFunction): void { /* do nothing */ }

    setDeleteParameters(_val: object): void { /* do nothing */ }

    setNewHandler(_newFunc: RecordActionFunction): void { /* do nothing */ }

    setNewParameters(_val: object): void { /* do nothing */ }

    setSaveHandler(_saveFunc: RecordActionFunction): void { /* do nothing */ }

    async openWorkEntryDialog(_params: WorkEntryDialogParams) { /* do nothing */ }

    logout(): void { /* do nothing */ }
}
